
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/detail/[id]",
      function () {
        return require("private-next-pages/category/detail/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/detail/[id]"])
      });
    }
  